export class ErroInternoServidor extends Error {
  constructor(message = 'Erro Interno do Servidor!') {
    super(message)
    this.name = 'ErroInternoServidor'
  }
}
